import validate from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/node_modules/nuxt/dist/pages/runtime/validate.js";
import current_45module_45global from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/middleware/currentModule.global.ts";
import help_45pages_45global from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/middleware/helpPages.global.ts";
import is_45authenticated_45global from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/middleware/isAuthenticated.global.ts";
import manifest_45route_45rule from "/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  current_45module_45global,
  help_45pages_45global,
  is_45authenticated_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "auth-custom": () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/middleware/auth.custom.ts"),
  "can-access-route": () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/middleware/canAccessRoute.ts"),
  guest: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/middleware/guest.ts"),
  unverified: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/middleware/unverified.ts"),
  verified: () => import("/home/forge/develop.freizeitpass-digital.de/releases/81557295/client/middleware/verified.ts")
}